<template>
    <div class="spinner-div">
      <div class="circle">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="loading-text">
        <div class="goon-text">Thinking...</div>
        <span>Hold tight</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingSpinner',
  };
  </script>